import React from "react";
import "./Milestone.css";

const Milestone = ({ title, description, date, isCompleted, img }) => {
  return (
    <div className={`milestone ${isCompleted ? "completed" : ""}`}>
      <div className="milestone-marker"></div>
      <div className="milestone-content">
        <img src={img} alt="logo" style={{ width: "8rem" }} />
        <h3>{title}</h3>
        <span className="milestone-date">{date}</span>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default Milestone;
